// client/src/pages/common/Unauthorized.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';

const Unauthorized = () => {
  const { t } = useTranslation(['business', 'common']);
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    if (user?.role === 'business') {
      navigate('/dashboard');
    } else if (user?.role === 'wholesaler') {
      navigate('/wholesaler/dashboard');
    } else if (user?.role === 'admin') {
      navigate('/admin/dashboard');
    } else {
      navigate('/');
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow flex items-center justify-center text-center px-4 pt-16 lg:pt-0">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md">
          <div className="mb-6">
            <svg
              className="mx-auto h-24 w-24 text-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            {t('business:unauthorized.title')}
          </h1>
          
          <p className="text-lg text-gray-600 mb-8">
            {t('business:unauthorized.message')}
          </p>
          
          <div className="space-y-3">
            {user ? (
              <button
                onClick={handleGoToDashboard}
                className="w-full bg-blue-600 text-white px-6 py-3 rounded-md shadow-md hover:bg-blue-700 transition-colors"
              >
                {t('business:unauthorized.goToDashboard')}
              </button>
            ) : (
              <Link
                to="/"
                className="block w-full bg-blue-600 text-white px-6 py-3 rounded-md shadow-md hover:bg-blue-700 transition-colors"
              >
                {t('business:unauthorized.goHome')}
              </Link>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Unauthorized;